module.exports = __webpack_public_path__ + "static/media/kaipass_placeholder.08b95633.png";